<template>
  <div>
    <template v-for="group in items">
      <ul :key="group.id">
        <li v-if="groupBy" class="group-header">
          <slot name="header" :header="group.header">{{group.header}}</slot>
        </li>
        <li v-for="item in group.data" :key="item.id" @click="$emit('liClick', item)">
          <div :class="[nav ? 'w-90' :'w-100', 'template' ]">
            <slot name="item" :item="item"><div class="text-left">{{item.value}}</div></slot>
          </div>
          <div class="w-10 nav" v-if="nav">
            <centered-container>
              <cms-icon width="15" height="15">
                <icon-arrow />
              </cms-icon>
            </centered-container>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import arrowNav from "../icons/arrow-nav";

export default {
  name: "cms-list",
  props: ["data", "dataStore", "dataInit", "nav", "groupBy"],
  components: {
    "icon-arrow": arrowNav
  },
  computed: {
    items() {
      var rowData = this.data || this.$store.getters[this.dataStore];
      for (let i = 0; i < rowData.length; i++) {
        rowData[i].id = rowData[i].id || `i${i}`;
        rowData[i].nav = rowData[i].nav || this.nav;
      }

      if (this.groupBy && rowData && rowData.length) {
        let groups = [...new Set(rowData.map(r => r[this.groupBy]))];
        let groupedData = groups.map((el, i) => {
          return {
            id: `g${i}`,
            header: el,
            data: rowData.filter(r => r[this.groupBy] === el)
          };
        });
        return groupedData;
      }

      return [{ id: "g0", header: null, data: rowData }];
    }
  },
  async beforeMount() {
    if (this.dataInit) {
      await this.$store.dispatch(this.dataInit);
    }
  }
};
</script>

<style scoped lang="scss">
ul {
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid $white-one-color;
  &:last-child {
    border-bottom: 1px solid $white-one-color;
  }
}

li {
  display: flex;

  &:nth-child(1):not(:last-child) {
    border-bottom: 1px solid $white-one-color;
  }

  &:not(.group-header) {
    margin-left: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  &:not(:nth-child(1)):not(:nth-child(2)) {
    border-top: 1px solid $white-one-color;
  }
}

.template,
.nav {
  display: inline-block;
}

.nav {
  color: $dark-sky-blue-color;
}
</style>